export const getImageUrl = (name) => {
  return new URL(`../assets/nav_icons/${name}.svg`, import.meta.url).href
}